/* SCA — Page produit Anciens formats — achat unique uniquement */
(() => {
  const root = document.querySelector('[data-sca-legacy-root]');
  if (!root) return;

  const productJsonEl = root.querySelector('[data-sca-product-json]');
  if (!productJsonEl) return;

  let product;

  try {
    product = JSON.parse(productJsonEl.textContent);
  } catch (err) {
    console.error('[SCA Legacy] JSON produit invalide', err);
    return;
  }

  const normalize = (value) => {
    return String(value || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '')
      .replace(/-/g, '');
  };

  const getOptionName = (option) => {
    if (typeof option === 'string') return option;
    if (option && typeof option.name === 'string') return option.name;
    return String(option || '');
  };

  const optIdx = {};

  (product.options || []).forEach((option, i) => {
    const name = getOptionName(option);
    optIdx[normalize(name)] = i;
  });

  const state = {
    format: root.dataset.defaultFormat || 'Comprimés',
    weight: root.dataset.defaultWeight || '100g'
  };

  const fmtMoney = (cents) => {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  function weightToKg(weight) {
    const value = normalize(weight);

    if (value.includes('kg')) {
      return parseFloat(value.replace('kg', '').replace(',', '.')) || 1;
    }

    if (value.includes('g')) {
      const grams = parseFloat(value.replace('g', '').replace(',', '.'));
      return grams ? grams / 1000 : null;
    }

    return null;
  }

  function formatSlug(format) {
    return normalize(format).includes('paillette') ? 'paillettes' : 'comprimes';
  }

  function getVariantFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');

    if (!variantId) return null;

    return (product.variants || []).find((v) => String(v.id) === String(variantId)) || null;
  }

  function getVariantOptionValue(variant, index) {
    if (index === 0) return variant.option1;
    if (index === 1) return variant.option2;
    if (index === 2) return variant.option3;
    return '';
  }

  function applyVariantToState(variant) {
    if (!variant) return;

    const formatIndex = optIdx.format;
    const weightIndex = optIdx.poids;

    if (typeof formatIndex !== 'undefined') {
      const value = getVariantOptionValue(variant, formatIndex);
      if (value) state.format = value;
    }

    if (typeof weightIndex !== 'undefined') {
      const value = getVariantOptionValue(variant, weightIndex);
      if (value) state.weight = value;
    }
  }

  function applyHashToState() {
    const h = normalize(window.location.hash);

    if (h.includes('paillette')) {
      state.format = 'Paillettes';
    } else if (h.includes('comprime')) {
      state.format = 'Comprimés';
    }
  }

  function applyInitialUrlState() {
    const variantFromUrl = getVariantFromUrl();

    if (variantFromUrl) {
      applyVariantToState(variantFromUrl);
    }

    applyHashToState();
  }

  applyInitialUrlState();

  function findVariant() {
    const formatIndex = optIdx.format;
    const weightIndex = optIdx.poids;

    if (typeof formatIndex === 'undefined' || typeof weightIndex === 'undefined') {
      console.warn('[SCA Legacy] Options Shopify introuvables.', {
        options: product.options,
        optIdx
      });
      return null;
    }

    const wantedFormat = normalize(state.format);
    const wantedWeight = normalize(state.weight);

    return (product.variants || []).find((v) => {
      const variantFormat = normalize(getVariantOptionValue(v, formatIndex));
      const variantWeight = normalize(getVariantOptionValue(v, weightIndex));

      return variantFormat === wantedFormat && variantWeight === wantedWeight;
    }) || null;
  }

  function openExistingNutritionModal() {
    const existingModalButton = document.querySelector('.benefits-slider-clean [data-open-nutrition-modal]');

    if (existingModalButton) {
      existingModalButton.click();
      return;
    }

    const relayButton = document.querySelector('[data-open-existing-nutrition-modal]');

    if (relayButton) {
      relayButton.click();
      return;
    }

    const nutritionSection = document.querySelector('#nutrition');

    if (nutritionSection) {
      nutritionSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  const els = {
    title: root.querySelector('[data-sca-title]'),
    subtitle: root.querySelector('[data-sca-subtitle]'),
    optionBtns: [...root.querySelectorAll('[data-sca-option]')],
    price: root.querySelector('[data-legacy-price]'),
    compare: root.querySelector('[data-legacy-compare]'),
    note: root.querySelector('[data-legacy-note]'),
    sFormat: root.querySelector('[data-summary-format]'),
    sWeight: root.querySelector('[data-summary-weight]'),
    form: root.querySelector('[data-sca-form]'),
    variantInput: root.querySelector('[data-variant-id]'),
    submitBtn: root.querySelector('[data-submit-btn]'),
    formError: root.querySelector('[data-form-error]'),
    thumbs: [...root.querySelectorAll('[data-sca-thumb]')],
    mediaItems: [...root.querySelectorAll('[data-sca-media-item]')],
    taste: root.querySelector('[data-taste]'),
    tasteEmoji: root.querySelector('[data-taste-emoji]'),
    nutritionOpen: root.querySelector('[data-sca-open-nutrition-modal]')
  };

  let activeMediaId = null;

  function syncUrl(variant) {
    const url = new URL(window.location.href);

    if (variant && variant.id) {
      url.searchParams.set('variant', variant.id);
    } else {
      url.searchParams.delete('variant');
    }

    url.hash = formatSlug(state.format);

    window.history.replaceState({}, '', url.toString());
  }

  function renderGallery() {
    const visibleThumbs = els.thumbs.filter((t) => t.dataset.thumbFormat === state.format);
    const visibleMedia = els.mediaItems.filter((m) => m.dataset.mediaFormat === state.format);

    els.thumbs.forEach((t) => {
      t.hidden = t.dataset.thumbFormat !== state.format;
    });

    const activeStillVisible =
      visibleThumbs.some((t) => t.dataset.thumbMediaId === String(activeMediaId)) ||
      visibleMedia.some((m) => m.dataset.mediaId === String(activeMediaId));

    if (!activeMediaId || !activeStillVisible) {
      activeMediaId =
        visibleThumbs.length > 0
          ? visibleThumbs[0].dataset.thumbMediaId
          : visibleMedia.length > 0
            ? visibleMedia[0].dataset.mediaId
            : null;
    }

    els.thumbs.forEach((t) => {
      t.classList.toggle('is-active', t.dataset.thumbMediaId === String(activeMediaId));
    });

    els.mediaItems.forEach((m) => {
      const isActive = m.dataset.mediaId === String(activeMediaId);
      m.classList.toggle('is-active', isActive);

      if (isActive) {
        const img = m.querySelector('img');

        if (img) {
          img.loading = 'eager';
          img.decoding = 'async';
        }
      }
    });
  }

  els.thumbs.forEach((t) => {
    t.addEventListener('click', () => {
      activeMediaId = t.dataset.thumbMediaId;
      renderGallery();
    });
  });

  if (els.nutritionOpen) {
    els.nutritionOpen.addEventListener('click', openExistingNutritionModal);
  }

  function render(options = {}) {
    const shouldSyncUrl = options.syncUrl !== false;

    if (normalize(state.format).includes('paillette')) {
      state.format = 'Paillettes';
    } else {
      state.format = 'Comprimés';
    }

    if (!state.weight) {
      state.weight = '100g';
    }

    els.optionBtns.forEach((btn) => {
      const opt = btn.dataset.scaOption;
      const val = btn.dataset.scaValue;

      const cur =
        opt === 'Format'
          ? state.format
          : state.weight;

      btn.classList.toggle('is-active', normalize(val) === normalize(cur));
    });

    if (els.title) {
      els.title.textContent = state.format === 'Paillettes'
        ? 'Spiruline en paillettes'
        : 'Spiruline en comprimés';
    }

    if (els.subtitle) {
      els.subtitle.textContent = state.format === 'Paillettes'
        ? els.subtitle.dataset.subPaillettes
        : els.subtitle.dataset.subComprimes;
    }

    if (els.taste) {
      els.taste.textContent = state.format === 'Paillettes'
        ? els.taste.dataset.tastePaillettes
        : els.taste.dataset.tasteComprimes;
    }

    if (els.tasteEmoji) {
      els.tasteEmoji.textContent = state.format === 'Paillettes'
        ? els.tasteEmoji.dataset.emojiPaillettes
        : els.tasteEmoji.dataset.emojiComprimes;
    }

    const variant = findVariant();

    if (!variant) {
      console.warn('[SCA Legacy] Variante introuvable pour :', {
        format: state.format,
        weight: state.weight,
        options: product.options,
        variants: product.variants
      });

      if (els.formError) {
        els.formError.textContent = "Cette combinaison n'est pas disponible.";
        els.formError.hidden = false;
      }

      if (els.submitBtn) els.submitBtn.disabled = true;
      if (els.price) els.price.textContent = '—';
      if (els.compare) els.compare.textContent = '';
      if (els.variantInput) els.variantInput.value = '';

      renderGallery();

      if (shouldSyncUrl) syncUrl(null);
      return;
    }

    if (els.formError) {
      els.formError.hidden = true;
    }

    if (els.submitBtn) {
      els.submitBtn.disabled = !variant.available;
    }

    if (els.price) {
      els.price.textContent = fmtMoney(variant.price);
    }

    if (els.compare) {
      const compareAt = variant.compare_at_price || 0;
      els.compare.textContent =
        compareAt > variant.price
          ? fmtMoney(compareAt)
          : '';
    }

    if (els.note) {
      if (variant.available) {
        const kg = weightToKg(state.weight);
        const kiloPrice = kg ? Math.round(variant.price / kg) : null;

        els.note.textContent = kiloPrice
          ? 'Soit ' + fmtMoney(kiloPrice) + '/kg · Achat unique · Livraison suivie'
          : 'Achat unique · ' + state.weight + ' · Livraison suivie';
      } else {
        els.note.textContent = 'Ce format est momentanément indisponible.';
      }
    }

    if (els.sFormat) {
      els.sFormat.textContent = state.format;
    }

    if (els.sWeight) {
      els.sWeight.textContent = state.weight;
    }

    if (els.variantInput) {
      els.variantInput.value = variant.id;
    }

    renderGallery();

    if (shouldSyncUrl) {
      syncUrl(variant);
    }
  }

  els.optionBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const opt = btn.dataset.scaOption;
      const val = btn.dataset.scaValue;

      if (opt === 'Format') {
        if (normalize(state.format) !== normalize(val)) {
          state.format = val;
          activeMediaId = null;
        }
      }

      if (opt === 'Poids') {
        state.weight = val;
      }

      render();
    });
  });

  window.addEventListener('hashchange', () => {
    applyHashToState();
    activeMediaId = null;
    render({ syncUrl: false });
  });

  if (els.form) {
    els.form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variant = findVariant();

      if (!variant || !variant.available) {
        if (els.formError) {
          els.formError.textContent = !variant
            ? "Cette combinaison n'est pas disponible."
            : "Ce format est momentanément indisponible.";
          els.formError.hidden = false;
        }

        return;
      }

      els.submitBtn.disabled = true;

      const payload = {
        items: [
          {
            id: variant.id,
            quantity: 1
          }
        ]
      };

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          throw new Error('add failed');
        }

        if (window.SCACart) {
          document.dispatchEvent(new CustomEvent('sca:cart:added'));
          els.submitBtn.disabled = false;
        } else if (root.dataset.redirectToCart === 'true') {
          window.location.href = '/cart';
        } else {
          els.submitBtn.disabled = false;
        }
      } catch (err) {
        if (els.formError) {
          els.formError.textContent = "Impossible d'ajouter au panier. Réessayez.";
          els.formError.hidden = false;
        }

        els.submitBtn.disabled = false;
      }
    });
  }

  render();
})();